import React, { useEffect, useState } from "react";
import moment from "moment";
import api from "../../api";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";

export const PaymentMethod = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const openEdit = (item) => setEditItem(item);
  const closeEdit = () => setEditItem(null);

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getPayMethod();
      if (response?.success) setData(response?.methods || []);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => { getData(); }, []);

  const deletePayMethod = async (id) => {
    if (!window.confirm("Are you sure you want to delete this payment method?")) return;
    try {
      const response = await api.deletePayMethod(id);
      if (response?.success) {
        notify.success("Payment method deleted successfully!");
        getData();
      }
    } catch (error) {
      notify.error("Something went wrong!");
    }
  };

  return (
    <>
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Payment Method</h3>
            <Table data={data} deletePayMethod={deletePayMethod} openEdit={openEdit} />
          </div>
        </div>
        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>
      <CreatePayMethodModal show={show} handleClose={handleClose} getPayMethod={getData} />
      {editItem && (
        <EditPayMethodModal item={editItem} handleClose={closeEdit} getPayMethod={getData} />
      )}
    </>
  );
};

const Table = ({ data, deletePayMethod, openEdit }) => {
  return (
    <div className="TableMain mt-3">
      <div className="table-responsive">
        <table className="table table-hover drivers-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Account No.</th>
              <th>Card No.</th>
              <th>Bank Name</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, key) => (
              <tr key={key}>
                <td><div className="table-text-dark w-max-c db">{item?.name}</div></td>
                <td><div className="table-text-dark" style={{ textTransform: "capitalize" }}>{item?.type}</div></td>
                <td><span className="table-text-dark w-max-c db">{item?.details?.accountNumber}</span></td>
                <td><span className="table-text-dark w-max-c db">{item?.details?.cardNumber}</span></td>
                <td><span className="table-text-dark w-max-c db">{item?.details?.bankName}</span></td>
                <td>
                  <span style={{
                    display: "inline-block",
                    padding: "3px 10px",
                    borderRadius: 20,
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: "capitalize",
                    background: item?.status === "active" ? "#d1fae5" : "#fee2e2",
                    color: item?.status === "active" ? "#065f46" : "#991b1b",
                  }}>
                    {item?.status || "—"}
                  </span>
                </td>
                <td>
                  <div className="d-flex gap-2 align-items-center">
                    <div className="edit p-2 cursor-pointer" onClick={() => openEdit(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </div>
                    <div className="delete p-2 cursor-pointer" onClick={() => deletePayMethod(item?._id)}>
                      <i className="fa-solid fa-trash"></i>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const PayMethodForm = ({ data, onChange }) => (
  <div className="row">
    <div className="col-12">
      <div className="form-group">
        <label>Name*</label>
        <input type="text" name="name" className="form-control" value={data?.name || ""} onChange={onChange} />
      </div>
    </div>
    <div className="col-6">
      <div className="form-group">
        <label>Type*</label>
        <select name="type" className="form-control" value={data?.type || ""} onChange={onChange}>
          <option value="">Select</option>
          <option value="cash">Cash</option>
          <option value="card">Card</option>
          <option value="account">Account</option>
          <option value="others">Others</option>
        </select>
      </div>
    </div>
    <div className="col-6">
      <div className="form-group">
        <label>Account Number</label>
        <input type="text" name="accountNumber" className="form-control" value={data?.accountNumber || ""} onChange={onChange} />
      </div>
    </div>
    <div className="col-6">
      <div className="form-group">
        <label>Card Number</label>
        <input type="number" name="cardNumber" className="form-control" value={data?.cardNumber || ""} onChange={onChange} />
      </div>
    </div>
    <div className="col-6">
      <div className="form-group">
        <label>Bank Name</label>
        <input type="text" name="bankName" className="form-control" value={data?.bankName || ""} onChange={onChange} />
      </div>
    </div>
  </div>
);

const CreatePayMethodModal = ({ show, handleClose, getPayMethod }) => {
  const [data, setData] = useState({});
  const onChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      const payload = {
        name: data?.name,
        type: data?.type,
        details: { accountNumber: data?.accountNumber, cardNumber: data?.cardNumber, bankName: data?.bankName },
      };
      const response = await api.addPayMethod(payload);
      if (response?.success) {
        getPayMethod();
        notify.success("Pay method successfully added!");
        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">Add Payment Method</div>
        <PayMethodForm data={data} onChange={onChange} />
        <div className="mt-4">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </Modal>
  );
};

const EditPayMethodModal = ({ item, handleClose, getPayMethod }) => {
  const [data, setData] = useState({
    name: item?.name || "",
    type: item?.type || "",
    accountNumber: item?.details?.accountNumber || "",
    cardNumber: item?.details?.cardNumber || "",
    bankName: item?.details?.bankName || "",
  });
  const onChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      const payload = {
        name: data?.name,
        type: data?.type,
        details: { accountNumber: data?.accountNumber, cardNumber: data?.cardNumber, bankName: data?.bankName },
      };
      const response = await api.updatePayMethod(item._id, payload);
      if (response?.success) {
        getPayMethod();
        notify.success("Payment method updated!");
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal show={true} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">Edit Payment Method</div>
        <PayMethodForm data={data} onChange={onChange} />
        <div className="mt-4">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit}>Update</button>
        </div>
      </div>
    </Modal>
  );
};
